import useGetDetailItem from "@hooks/Partner/useGetPartner";
import formMapper from "@mappers/Modules/partner/PartnerItem.mapper";
import updateItem from "@services/Partner/updateItem";
import Modify from "@shared/FormTemplates/Modify";
import validator from "@validators/Modules/partner/partner.validate";
import { ReactElement } from "react";
import ModifyForm from "./ModifyForm";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
